import { Grid } from '@/components/atoms/Grid'
import { FC } from 'react'

const DropdownMenuItemsGrid: FC<Rest> = ({ children, ...rest }) => (
  <Grid minWidth={256} {...rest} position="relative">
    {children}
  </Grid>
)

export default DropdownMenuItemsGrid
